import { render, staticRenderFns } from "./TranslationEditor.vue?vue&type=template&id=4d661c40"
import script from "./TranslationEditor.vue?vue&type=script&lang=ts"
export * from "./TranslationEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports